import { useCallback } from 'react'
import { GetAdvancedCaseloadParticipantsDocument } from '../app/advancedCaseload.generated'
import { GetAdvancedPatientHistoryDocument } from './advancedPatientHistory.generated'
import { GetAdvancedPatientHistoryFormTypesDocument } from './advancedPatientHistoryFormTypes.generated'
import { GetAdvancedUncancelledInProgramCallsDocument } from './advancedUncancelledInProgramCalls.generated'
import { useDeleteAdvancedPatientHistoryEntryMutation } from './deleteAdvancedPatientHistoryEntry.generated'
import { HOME_VIEW_CASELOAD } from './homeViewCaseload'

// Standard's window: an entry the dashboard wrote can be removed for two days.
const DELETION_WINDOW_IN_HOURS = 48

export const isDeletable = ({ createdAt, source }: { createdAt: string; source?: string | null }): boolean =>
  source === 'dashboard' && Date.now() - new Date(createdAt).getTime() <= DELETION_WINDOW_IN_HOURS * 3600 * 1000

export const useDeletePatientHistoryEntry = (uid: string) => {
  const [mutate, { loading, error }] = useDeleteAdvancedPatientHistoryEntryMutation({
    // Deleting a note can make a completed call await a note again, and only the server knows that.
    refetchQueries: [
      { query: GetAdvancedPatientHistoryDocument, variables: { uid } },
      { query: GetAdvancedPatientHistoryFormTypesDocument, variables: { uid } },
      { query: GetAdvancedUncancelledInProgramCallsDocument, variables: { uid } },
      HOME_VIEW_CASELOAD,
      GetAdvancedCaseloadParticipantsDocument,
    ],
  })

  const remove = useCallback((entryID: string) => mutate({ variables: { entryID } }), [mutate])

  return { remove, deleting: loading, error }
}
